import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import { Legal } from './pages/Legal';
import CaseStudy from './pages/CaseStudy';
import NotFound from './pages/NotFound';
import { CommandPalette } from './components/CommandPalette';
import { CursorSpotlight } from './components/CursorSpotlight';
import { ScrollReveal } from './components/ScrollReveal';
import { RouteScroll } from './components/RouteScroll';

export const App = () => {
  return (
    <>
      <CursorSpotlight />
      <ScrollReveal />
      <RouteScroll />
      <CommandPalette />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/en" element={<Landing />} />
        <Route path="/work/:slug" element={<CaseStudy />} />
        <Route path="/en/work/:slug" element={<CaseStudy />} />
        <Route path="/impressum" element={<Legal doc="impressum" />} />
        <Route path="/en/imprint" element={<Legal doc="impressum" />} />
        <Route path="/datenschutz" element={<Legal doc="datenschutz" />} />
        <Route path="/en/privacy" element={<Legal doc="datenschutz" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
